<template lang="pug">
    .component-accordion
        ul.accordion(data-accordion, :data-allow-all-closed="allClosed", :data-multi-expand="multiExpand", v-f-accordion="")
            li.accordion-item(v-for="title in titles", data-accordion-item)
                a.accordion-title(href="#") {{title}}
                div.accordion-content(data-tab-content)
                    slot(:name="title")

</template>
<script type="text/babel">
    export default{
        name: "Accordion",
        components: {},
        data(){
            return {}
        },
        methods: {},
        props: ['titles','multiExpand','allClosed']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// Accordion.vue?1f184ccc